import { createFileRoute, Link } from "@tanstack/react-router";
import { useState, type FormEvent } from "react";
import { authClient } from "@/api/auth";
import { Button } from "@/components/ui/button";
import { Field, Input } from "@/components/ui/field";
import { AuthLayout } from "@/features/auth/auth-layout";
import { noindexHead } from "@/features/marketing/seo";
import { t } from "@/i18n";

export const Route = createFileRoute("/forgot-password")({ head: () => noindexHead(t("marketing.seo.forgot")), component: ForgotPage });

function ForgotPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    // Always report success — never confirm whether an email exists.
    await authClient.requestPasswordReset({ email, redirectTo: `${window.location.origin}/reset-password` }).catch(() => undefined);
    setBusy(false); setSent(true);
  };

  return (
    <AuthLayout title={t("auth.reset")} footer={<Link to="/login" className="font-semibold text-accent">{t("common.back")}</Link>}>
      {sent ? (
        <p className="text-[15px] text-text-secondary">{t("auth.resetSent")}</p>
      ) : (
        <form onSubmit={submit} className="flex flex-col gap-4">
          <Field label={t("common.email")}><Input type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} /></Field>
          <Button type="submit" size="lg" loading={busy}>{t("auth.sendResetLink")}</Button>
        </form>
      )}
    </AuthLayout>
  );
}
